<template>
  <v-container fluid style="height: 100%;">
    <v-row>
      <v-col cols="12" align="left">
        <h3 style="font-weight: 500;">
          <v-icon :color="colorTheme">mdi-cellphone-sound</v-icon>
          {{ $t("manageMobileTeams") }}
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="3" sm="4" cols="12" style="padding-bottom: 0; max-height: 60px;">
        <v-text-field
          solo
          :label="$t('search')"
          append-icon="mdi-magnify"
          single-line
          v-model="search"
          :color="colorTheme"
        ></v-text-field>
      </v-col>
      <v-col lg="2" md="3" sm="4" cols="12" style="padding-bottom: 0;">
        <v-select
          :items="opcionesvinc"
          solo
          :color="colorTheme"
          v-model="filterVin"
          :label="$t('filterVehicles')"
        ></v-select>
      </v-col>
      <v-col lg="2" md="3" sm="4" cols="12" style="padding-bottom: 0;">
        <v-btn
          style="width: 100%; margin: 0;"
          large
          :color="colorTheme"
          class="white--text"
          v-on:click="openAddMobile()"
        >
          {{ $t("addEquipment").toUpperCase() }}
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col lg="12" sm="12" md="12">
        <v-data-table
          :no-data-text="$t('noResults')"
          v-model="allMobiles"
          :headers="headersMobilesDetails"
          :items="listMovil"
          :search="search"
          show-select
          item-key="id"
          :items-per-page="5"
          class="elevation-1"
          :loading="progressMovil"
          :loading-text="$t('loadingTextForTable')"
          :footer-props="{
            'items-per-page-text': $t('rows'),
            'items-per-page-all-text': $t('all')
          }"
        >
          <template v-slot:item.mobile="{ item }">
            <td
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.mobile }}</td>
          </template>
          <template v-slot:item.IMEI="{ item }">
            <td
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.IMEI }}</td>
          </template>
          <template v-slot:item.marca="{ item }">
            <td
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.marca }}</td>
          </template>
          <template v-slot:item.model="{ item }">
            <td
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.model }}</td>
          </template>
          <template v-slot:item.OS="{ item }">
            <td
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.OS }}</td>
          </template>
          <template v-slot:item.Bonding="{ item }">
            <td
              v-if="item.Bonding != 'N/A'"
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.Bonding.Operator }}</td>
            <td
              v-else
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.Bonding }}</td>
          </template>
          <template v-slot:item.act="{ item }">
            <td
              style="display: block; padding: 8px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >
              <v-menu bottom left z-index="18" nudge-width="100">
                <template v-slot:activator="{ on }">
                  <v-btn :color="colorTheme" icon text v-on="on">
                    <v-icon v-show="item === selectedItem || visible == false">mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="item.Bonding == 'N/A'"
                    :color="colorTheme"
                    v-on:click="vincular(item)"
                    dense
                  >
                    <v-list-item-title>{{ $t("link") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-else :color="colorTheme" dense v-on:click="desvincular(item)">
                    <v-list-item-title>{{ $t("unlink") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item :color="colorTheme" dense v-on:click="editMobile(item)">
                    <v-list-item-title>{{ $t("edit") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item :color="colorTheme" dense v-on:click="deleteMobile(item)">
                    <v-list-item-title>{{ $t("delete") }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
          >{{ $t("noResults") }} : "{{ search }}".</v-alert>
          <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }} </template>
        </v-data-table>
      </v-col>
      <v-dialog v-model="addnew" max-width="800">
        <v-card>
          <v-card-title class="headline">{{ $t("newMobileEquipment").toUpperCase() }}</v-card-title>
          <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col lg="8" md="8" sm="12" cols="12">
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-row>
                      <v-col lg="12" md="12" sm="12" cols="12">
                        <v-text-field
                          label="IMEI"
                          :rules="IMEIRules"
                          v-model="IMEI"
                          outlined
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col lg="12" md="12" sm="12" cols="12">
                        <v-text-field
                          :label="$t('serialNumber')"
                          :rules="serialNumberRules"
                          v-model="serialNumber"
                          outlined
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col lg="12" md="12" sm="12" cols="12">
                        <v-text-field
                          :color="colorTheme"
                          v-model="phone"
                          :label="$t('number')"
                          outlined
                          :rules="phoneRules"
                          required
                          v-on:keypress="isNumber(event)"
                        >
                          <template v-slot:prepend>
                            <vue-tel-input v-bind="bindProps">
                              <template v-slot:arrow-icon>
                                <strong>+{{ country }}</strong>
                              </template>
                            </vue-tel-input>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col lg="6" md="6" sm="12" cols="12">
                        <v-text-field
                          :label="$t('brand')"
                          v-model="brand"
                          :rules="brandRules"
                          outlined
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col lg="6" md="6" sm="12" cols="12">
                        <v-text-field
                          v-model="model"
                          outlined
                          :rules="modelRules"
                          :label="$t('model')"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col lg="12" md="12" sm="12" cols="12">
                        <v-select
                          :label="$t('operativeSystem')"
                          v-model="operativeSystem"
                          :items="listOS"
                          item-text="Name"
                          item-value="id"
                          outlined
                          required
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
                <v-col lg="4" md="4" sm="12" cols="12">
                  <v-col cols="12">
                    <div style="border-color: lightgray; border-style: solid; border-width: 7px;">
                      <qrcode-vue :value="value" size="176" style="padding-top: 7px;"></qrcode-vue>
                    </div>
                    <h4>{{ $t("scanPhone") }}</h4>
                  </v-col>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :color="colorTheme"
              text
              v-on:click="cancelMobile()"
            >{{ $t("cancel").toUpperCase() }}</v-btn>

            <v-btn
              :color="colorTheme"
              text
              v-on:click="addMobile()"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editMob" max-width="800">
        <v-card>
          <v-card-title class="headline">{{ $t("editMobileTeam").toUpperCase() }}</v-card-title>
          <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col lg="12" md="12" sm="12" cols="12">
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-row>
                      <v-col lg="12" md="12" sm="12" cols="12">
                        <v-text-field
                          label="IMEI"
                          :rules="IMEIRules"
                          v-model="IMEI"
                          outlined
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col lg="12" md="12" sm="12" cols="12">
                        <v-text-field
                          :label="$t('serialNumber')"
                          :rules="serialNumberRules"
                          v-model="serialNumber"
                          outlined
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col lg="12" md="12" sm="12" cols="12">
                        <v-text-field
                          :color="colorTheme"
                          v-model="phone"
                          :label="$t('number')"
                          outlined
                          :rules="phoneRules"
                          required
                          v-on:keypress="isNumber(event)"
                        >
                          <template v-slot:prepend>
                            <vue-tel-input v-bind="bindProps">
                              <template v-slot:arrow-icon>
                                <strong>+{{ country }}</strong>
                              </template>
                            </vue-tel-input>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col lg="6" md="6" sm="12" cols="12">
                        <v-text-field
                          :label="$t('brand')"
                          v-model="brand"
                          :rules="brandRules"
                          outlined
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col lg="6" md="6" sm="12" cols="12">
                        <v-text-field
                          v-model="model"
                          outlined
                          :rules="modelRules"
                          :label="$t('model')"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col lg="12" md="12" sm="12" cols="12">
                        <v-select
                          :label="$t('operativeSystem')"
                          v-model="operativeSystem"
                          :items="listOS"
                          item-text="Name"
                          item-value="id"
                          outlined
                          required
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :color="colorTheme"
              text
              v-on:click="cancelMobile()"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
            <v-btn
              :color="colorTheme"
              text
              v-on:click="confirmEdit()"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="confirm" hide-overlay persistent width="365">
        <v-card>
          <v-card-title class="headline" style="font-size: 14px !important;">
            {{
            $t("deleteConfirmMo").toUpperCase()
            }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="padding-top: 11px;">{{ delMobile.mobile }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmation(false)"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmation(true)"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="restriction" hide-overlay persistent width="357">
        <v-card>
          <v-card-title class="headline" style="font-size: 14px !important;">
            {{
            titleRestriction
            }}
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :color="colorTheme"
              @click="restriction = false"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="linkup" max-width="750">
        <v-card>
          <v-card-title class="headline">
            {{
            $t("selectMobileEquipment").toUpperCase()
            }}
          </v-card-title>
          <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
          <v-card-text>
            <v-container style="padding-top: 17px;">
              <v-row>
                <div
                  class="text--primary"
                  style="font-weight: 500; font-size: 25px;"
                >{{ $t("mobileEquipment") }}:</div>
                <div class="text--primary ml-2" style="font-size: 23px;">{{ itemMobile.phone }}</div>
              </v-row>
            </v-container>
            <v-row>
              <v-col lg="6" md="6" sm="12" cols="12" style="padding-bottom: 0;">
                <v-text-field
                  solo
                  :label="$t('search')"
                  append-icon="mdi-magnify"
                  v-model="searchOperator"
                  :color="colorTheme"
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="padding-top: 0;">
                <v-data-table
                  :no-data-text="$t('noResults')"
                  v-model="selected"
                  :headers="headersOperators"
                  :items="listOperatorsWithoutP"
                  :search="searchOperator"
                  single-select
                  item-key="id"
                  show-select
                  :items-per-page="5"
                  class="elevation-1"
                  :footer-props="{
                    'items-per-page-text': $t('rows'),
                    'items-per-page-all-text': $t('all')
                  }"

                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.Operator }}</td>
                    <td class="text-xs-center">{{ props.item.License }}</td>
                    <td class="text-xs-center">{{ props.item.LicenseExpiration }}</td>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="error"
                    icon="mdi-alert"
                  >{{ $t("noResults") }} : "{{ searchOperator }}".</v-alert>
                  <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }} </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn :color="colorTheme" text @click="cancelLinkup()">
              {{
              $t("cancel").toUpperCase()
              }}
            </v-btn>

            <v-btn :color="colorTheme" text @click="linkupMobile(selected)">
              {{
              $t("link").toUpperCase()
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="openDesvincular" hide-overlay persistent width="505">
        <v-card>
          <v-card-title class="headline">
            {{
            $t("unlink").toUpperCase()
            }}
          </v-card-title>
          <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
          <v-card-text style="padding-top: 11px;">
            <v-list-item three-line>
              <v-row>
                <v-col lg="4" md="4" sm="12" cols="12">
                  <v-list-item-content align="center">
                    <v-list-item-title
                      class="headline"
                      style="font-size: 20px !important; padding-bottom: 8px;"
                    >{{ $t("operator") }}</v-list-item-title>
                    <v-list-item-subtitle>{{ name }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-col>
                <v-col lg="4" md="4" sm="12" cols="12" align="center" style="padding-top: 25px;">
                  <v-img
                    v-if="!this.$vuetify.theme.dark"
                    src="../assets/Desvincular-black.png"
                    alt="Sunny image"
                    width="80"
                  ></v-img>
                  <v-img
                    v-if="this.$vuetify.theme.dark"
                    src="../assets/Desvincular-white.png"
                    alt="Sunny image"
                    width="80"
                  ></v-img>
                </v-col>
                <v-col lg="4" md="4" sm="12" cols="12">
                  <v-list-item-content align="center">
                    <v-list-item-title
                      class="headline"
                      style="font-size: 20px !important; padding-bottom: 8px;"
                    >{{ $t("mobileEquipment") }}</v-list-item-title>
                    <v-list-item-subtitle>{{ itemMobile.phone }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmDesv(false)"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmDesv(true)"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import moment from "moment";
import QrcodeVue from "qrcode.vue";
import { VueTelInput } from "vue-tel-input";

export default {
  name: "operator",
  components: {
    VueTelInput,
    QrcodeVue
  },
  data() {
    return {
      search: "",
      selectedItem: false,
      addnew: false,
      valid: true,
      phone: "",
      phoneRules: [v => !!v || this.$t("required")],
      country: 52,
      bindProps: {
        mode: "international",
        maxLen: 25,
        inputOptions: {
          showDialCode: true
        }
      },
      serialNumber: "",
      serialNumberRules: [v => !!v || this.$t("required")],
      IMEI: "",
      IMEIRules: [v => !!v || this.$t("required")],
      brand: "",
      brandRules: [v => !!v || this.$t("required")],
      model: "",
      modelRules: [v => !!v || this.$t("required")],
      operativeSystem: 0,
      menuDate: false,
      itemMobile: [],
      confirm: false,
      delMobile: {},
      titleRestriction: "",
      restriction: false,
      linkup: false,
      searchOperator: "",
      selected: [],
      openDesvincular: false,
      value: "",
      name: "",
      listOS: [
        { id: 0, Name: i18n.t("other") },
        { id: 1, Name: "ANDROID" },
        { id: 2, Name: "BLACKBERRY" },
        { id: 3, Name: "HUAWEI" },
        { id: 4, Name: "IOS" },
        { id: 5, Name: "NOKIA" },
        { id: 6, Name: "PLASMA" },
        { id: 7, Name: "POSTMARKET" },
        { id: 8, Name: "PURE" },
        { id: 9, Name: "SAILFISH" },
        { id: 10, Name: "TIZEN" },
        { id: 11, Name: "UBUNTU" },
        { id: 12, Name: "SAMSUNG" },
        { id: 13, Name: "WINDOWS" }
      ],
      editMob: false,
      opcionesvinc: [i18n.t("all"), i18n.t("entail"), i18n.t("noEntail")]
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setTitle", this.$t("traffic"));
    this.$store.dispatch("getCarrierInfo");
    this.$store.commit("setPageHeader", [
      this.$t("entailment"),
      "",
      "",
      "",
      true
    ]);
    this.$store.dispatch("ListofOperators");
    this.$store.dispatch("ListofMovil");
  },
  computed: {
    ...mapState([
      "colorTheme",
      "headersMobilesDetails",
      "allMobiles",
      "listOperatorsWithoutP",
      "progressMovil",
      "visible",
      "valueDeterminate",
      "listMovil",
      "headersOperators"
    ]),
    filterVin: {
      get: function() {
        return this.$store.state.filterVin;
      },
      set: function(val) {
        this.$store.commit("filterVin", val);
        this.$store.dispatch("ListofMovil");
        // console.log(val);
      }
    }
  },
  methods: {
    openAddMobile() {
      var qrToken = {
        token: this.$store.state.token,
        carriedId: this.$store.state.carrierId
      };
      this.value = JSON.stringify(qrToken);
      this.addnew = true;
    },
    vincular(val) {
      this.itemMobile = JSON.parse(JSON.stringify(val));
      this.linkup = true;
      this.$store.dispatch("ListofOperators");
    },
    desvincular(val) {
      this.itemMobile = val;
      this.name = this.itemMobile.Bonding;
      this.openDesvincular = true;
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    addMobile() {
      if (this.$refs.form.validate()) {
        var item = {
          IMEI: this.IMEI,
          CallingCode: this.country,
          PhoneNumber: this.phone,
          SO: this.operativeSystem,
          BrandName: this.brand,
          Model: this.model,
          SerialNumber: this.serialNumber
        };

        this.$store.dispatch("AddMovil", item);

        this.$refs.form.reset();
        this.addnew = false;
      }
    },
    cancelMobile() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.addnew = false;
      this.editMob = false;
    },
    editMobile(val) {
      var OSS =
        val.OS == "ANDROID"
          ? 1
          : val.OS == "BLACKBERRY"
          ? 2
          : val.OS == "HUAWEI"
          ? 3
          : val.OS == "IOS"
          ? 4
          : val.OS == "NOKIA"
          ? 5
          : val.OS == "PLASMA"
          ? 6
          : val.OS == "POSTMARKET"
          ? 7
          : val.OS == "PURE"
          ? 8
          : val.OS == "SAILFISH"
          ? 9
          : val.OS == "TIZEN"
          ? 10
          : val.OS == "UBUNTU"
          ? 11
          : val.OS == "SAMSUNG"
          ? 12
          : val.OS == "WINDOWS"
          ? 13
          : 0;
      this.itemMobile = JSON.parse(JSON.stringify(val));
      this.phone = val.mobile;
      this.IMEI = val.IMEI;
      this.brand = val.marca;
      this.model = val.model;
      this.operativeSystem = OSS;
      this.country = val.CallingCode;
      this.serialNumber = val.SerialNumber;
      this.editMob = true;
    },
    confirmEdit() {
      this.itemMobile.mobile = this.phone;
      this.itemMobile.IMEI = this.IMEI;
      this.itemMobile.marca = this.brand;
      this.itemMobile.model = this.model;
      this.itemMobile.OS = this.operativeSystem;
      this.itemMobile.CallingCode = this.country;
      this.itemMobile.SerialNumber = this.serialNumber;
      this.$store.dispatch("EditMobile", this.itemMobile);
      this.$refs.form.reset();
      this.editMob = false;
    },
    deleteMobile(val) {
      //  console.log(val);
      //var operator = this.$store.getters.getOperator(val.Bonding);
      //console.log(operator);
      //if (operator.enViaje == true) {
      //  this.titleRestriction = this.$t("restrictionTravelM");
      //  this.restriction = true;
      //} else
      if (val.Bonding != "N/A") {
        this.titleRestriction = this.$t("restrictionOperator");
        this.restriction = true;
      } else {
        this.delMobile = val;
        this.confirm = true;
      }
    },
    confirmation(val) {
      if (val) {
        //   console.log(this.delMobile.IMEI);
        this.$store.dispatch("DeleteMobile", this.delMobile.IMEI);
      }
    },
    linkupMobile(val) {
      if (val.length != 0) {
        //    console.log(val);
        var item = {
          id: val[0].id,
          name: val[0].Operator,
          licenseId: val[0].License,
          licenseType: val[0].Type,
          licenseExp: val[0].LicenseExpiration,
          Address: val[0].Address,
          Bonding: this.itemMobile.Bonding
        };
        //this.$store.dispatch("EditOperator", item);
        this.linkup = false;
      } else {
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("selectAnOperator")
        });
      }
    },
    cancelLinkup() {
      this.linkup = false;
      this.selected = [];
    },
    confirmDesv(val) {
      if (!val) {
        this.openDesvincular = false;
      } else {
        //  console.log(this.itemMobile);
        this.openDesvincular = false;
      }
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>
<style>
.vti__input {
  display: none;
}

.vti__dropdown {
  font-size: 19px;
  font-weight: lighter;
}
.v-input__prepend-outer {
  margin-top: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 0;
}

.vue-tel-input {
  width: 70px;
  height: 56px;
}
</style>
